<template>
	<section class="container-components">
		<accordion>
			<template v-slot:header>Cabeçalho</template>
			<template v-slot:content>
				<div class="flex flex-start w-full justify-between">
					<Search width="40%" height="40px" class="pl-3" @searchtext="onSearch($event)" />
					<div class="flex flex-row">
						<Button
							height="40px"
							width="150px"
							margin-left="10px"
							border-radius="5px"
							title="Novo componente"
							:icon="{ type: 'plus', size: '14px', color: '#219653' }"
							@click="
								formData.secao_id = 1;
								modalCriarComponente = !modalCriarComponente;
							"
						/>
					</div>
				</div>
				<div class="mt-5 w-full mb-5">
					<ActionBar v-if="componentesHeader.length" @on-change="onChangeOrder" />
				</div>
				<div class="w-full flex">
					<div
						class="section-componentes w-full flex flex-wrap"
						:class="{ 'justify-between': componentes.length >= 4 }"
					>
						<Componente
							v-for="(componente, index) of componentesHeader"
							:key="index"
							:data="componente"
							:class="{ 'mr-4': componentes.length < 4 }"
							@selected="goToDetails($event)"
							@dropdown-action="dropdownActions($event)"
						/>
					</div>
				</div>
			</template>
		</accordion>
		<br />
		<accordion :open-by-default="true">
			<template v-slot:header>Páginas</template>
			<template v-slot:content>
				<div class="flex flex-start w-full justify-between">
					<Search width="40%" height="40px" class="pl-3" @searchtext="onSearch($event)" />
					<div class="flex flex-row">
						<Button
							height="40px"
							width="150px"
							margin-left="10px"
							border-radius="5px"
							title="Novo componente"
							:icon="{ type: 'plus', size: '14px', color: '#219653' }"
							@click="
								formData.secao_id = 2;
								modalCriarComponente = !modalCriarComponente;
							"
						/>
					</div>
				</div>
				<div class="mt-5 w-full mb-5">
					<ActionBar v-if="componentesBody.length" @on-change="onChangeOrder" />
				</div>
				<div class="w-full flex flex-col">
					<div v-if="componentesBody.length == 0" class="dica">
						<center>
							<font-awesome-icon size="sm" color="#28c76f" icon="lightbulb" /> Nenhum componente foi
							adicionado. Toque em "novo componente" para começar.
						</center>
					</div>
					<span v-else class="dica mb-2">
						<font-awesome-icon size="sm" color="#28c76f" icon="lightbulb" /> Toque no
						<i class="mdi mdi-drag"></i> e arraste para reordenar.
					</span>
					<draggable
						:list="componentesBody"
						class="section-componentes w-full flex flex-wrap"
						:class="{ 'justify-between': componentesBody.length >= 4 }"
						@change="updateComponentOrder"
					>
						<!-- <div
						class="section-componentes w-full flex flex-wrap"
						:class="{ 'justify-between': componentes.length >= 4 }"
					> -->
						<Componente
							v-for="(componente, index) of componentesBody"
							:key="index"
							:data="componente"
							:class="{ 'mr-4': componentesBody.length < 4 }"
							@selected="goToDetails($event)"
							@dropdown-action="dropdownActions($event)"
						/>
						<!-- </div> -->
					</draggable>
				</div>
			</template>
		</accordion>
		<br />
		<accordion>
			<template v-slot:header>Footer</template>
			<template v-slot:content>
				<div class="flex flex-start w-full justify-between">
					<Search width="40%" height="40px" class="pl-3" @searchtext="onSearch($event)" />
					<div class="flex flex-row">
						<Button
							height="40px"
							width="150px"
							margin-left="10px"
							border-radius="5px"
							title="Novo componente"
							:icon="{ type: 'plus', size: '14px', color: '#219653' }"
							@click="
								formData.secao_id = 3;
								modalCriarComponente = !modalCriarComponente;
							"
						/>
					</div>
				</div>
				<div class="mt-5 w-full mb-5">
					<ActionBar v-if="componentesFooter.length" @on-change="onChangeOrder" />
				</div>
				<div class="w-full flex">
					<div
						class="section-componentes w-full flex flex-wrap"
						:class="{ 'justify-between': componentes.length >= 4 }"
					>
						<Componente
							v-for="(componente, index) of componentesFooter"
							:key="index"
							:data="componente"
							:class="{ 'mr-4': componentes.length < 4 }"
							@selected="goToDetails($event)"
							@dropdown-action="dropdownActions($event)"
						/>
					</div>
				</div>
			</template>
		</accordion>
		<Modal
			v-if="modalCriarComponente"
			title="Novo componente"
			width="30%"
			max-width="600px"
			@closemodal="modalCriarComponente = !modalCriarComponente"
			@created="onCreatedModal($event)"
		>
			<template v-slot:modalcontent>
				<form method="POST" @submit="createComponent($event)">
					<div class="input-group flex flex-col mb-2">
						<label for="descricao">Descrição:</label>
						<input v-model="formData.descricao" required type="text" name="descricao" />
					</div>
					<div class="input-group flex flex-col mb-2">
						<label for="tipo">Posição na página:</label>
						<input v-model="formData.ordem" type="number" required name="tipo" />
					</div>
					<div class="flex flex-col mb-2">
						<label class="label-select" for="">Tipo:</label>
						<div class="flex flex-col items-center tipo-box">
							<div
								v-for="(tipo, index) in tipos"
								:key="index"
								class="tipo-container flex-col"
								:class="{ 'tipo-selected': formData.tipo_id == tipo.tipo_id }"
								@click="
									formData.tipo_id === tipo.tipo_id
										? (formData.tipo_id = '')
										: (formData.tipo_id = tipo.tipo_id)
								"
							>
								<img
									class="image-layout-desc"
									:src="require(`./layout-imagens/${tipo.tipo_id}.png`)"
									alt=""
								/>
								<span>{{ tipo.descricao }}</span>
							</div>
						</div>
					</div>
					<div class="input-group flex flex-col">
						<label for="">Página:</label>
						<select v-model="formData.pagina_id">
							<option v-for="(pagina, index) in paginas" :key="index" :value="pagina.pagina_id">
								{{ pagina.descricao }}
							</option>
						</select>
					</div>
					<div class="flex flex-row mt-4 items-center justify-center">
						<Button
							height="40px"
							margin-left="10px"
							width="150px"
							border-radius="5px"
							title="Cancelar"
							background-color="#d00000"
							title-color="#FFF"
							:icon="{
								type: 'x',
								size: '14px',
								color: '#FFF',
							}"
							@click="modalCriarComponente = !modalCriarComponente"
						/>
						<Button
							height="40px"
							width="150px"
							margin-left="10px"
							border-radius="5px"
							title="Salvar"
							title-color="#FFF"
							background-color="#219653"
							:icon="{
								type: 'save',
								size: '14px',
								color: '#FFF',
							}"
						/>
					</div>
				</form>
			</template>
		</Modal>
	</section>
</template>

<script>
import Search from '@/layout/components/search/new';
import Button from '@/layout/components/buttons/Default';
import ActionBar from '@/layout/components/actionbar/actionbar';
import Componente from '@/layout/components/cards/componente';
import * as ecAxios from '@/util/ecAxios';
import Modal from '@/layout/components/modal/centered';
import draggable from 'vuedraggable';
import Accordion from '../../layout/components/accordion/Accordion';

export default {
	components: {
		Search,
		Button,
		ActionBar,
		Componente,
		Accordion,
		Modal,
		draggable,
	},
	data() {
		return {
			componentes: [],
			search: '',
			tipos: [],
			errorToastOptions: {
				position: 'bottom-right',
				timeout: 5000,
				closeOnClick: true,
				pauseOnFocusLoss: true,
				pauseOnHover: true,
				draggable: true,
				draggablePercent: 0.6,
				showCloseButtonOnHover: false,
				hideProgressBar: true,
				closeButton: 'button',
				icon: true,
				rtl: false,
			},
			formData: {
				descricao: '',
				tipo_id: null,
				pagina_id: 2,
				secao_id: 1,
				ordem: 1,
			},
			paginas: [],
			modalCriarComponente: false,
		};
	},
	computed: {
		componentesHeader() {
			return this.componentes.filter((componente) => {
				if (componente.secao && componente.secao.secao_id === 1) {
					return true;
				}
				return false;
			});
		},
		// componentesBody() {
		// 	return this.componentes.filter((componente) => {
		// 		if (!componente.secao || componente.secao.secao_id === 2) {
		// 			return true;
		// 		}
		// 		return false;
		// 	});
		// },
		componentesBody: {
			get() {
				return this.componentes.filter((componente) => {
					if (!componente.secao || componente.secao.secao_id === 2) {
						return true;
					}
					return false;
				});
			},

			set(newValue) {
				this.componentes = newValue;
			},
		},
		componentesFooter() {
			return this.componentes.filter((componente) => {
				if (componente.secao && componente.secao.secao_id === 3) {
					return true;
				}
				return false;
			});
		},
	},
	created() {
		this.getAllComponents();
	},
	methods: {
		onChangeOrder(event) {
			this.getAllComponents(null, event, 'asc');
		},
		onSearch(text) {
			this.getAllComponents(text);
		},
		onCreatedModal() {
			this.getAllComponentTypes();
			this.getAllPages();
		},
		async getAllPages() {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENT_PAGINA_SHOWALL}`;
				const { data } = await ecAxios.connection().get(url);
				if (!data.error) {
					this.paginas = data.paginas;
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error, 'Erro', this.errorToastOptions);
			}
		},
		async getAllComponentTypes() {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENT_TIPO_SHOWALL}`;
				const { data } = await ecAxios.connection().get(url);
				if (!data.error) {
					this.tipos = data.tipos;
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error, 'Erro', this.errorToastOptions);
			}
		},
		dropdownActions(info) {
			switch (info.action) {
				case 'edit':
					this.editComponent(info.data.componente_id);
					break;
				case 'delete':
					this.deleteComponent(info.data.componente_id);
					break;
				default:
					break;
			}
		},

		async deleteComponent(componenteId) {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENT_DELETE}/${componenteId}`;
				const { data } = await ecAxios.connection().delete(url);
				if (!data.error) {
					this.getAllComponents();
					this.$toast.success(data.message, 'Sucesso', this.errorToastOptions);
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error.message, 'Erro', this.errorToastOptions);
			}
		},
		async getAllComponents(search = null, orderBy = 'ordem', direction = 'asc') {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENTE_SHOWALL}`;
				const { data } = await ecAxios.connection().get(url, {
					params: {
						search,
						orderBy,
						direction,
					},
				});
				if (!data.error) {
					this.componentes = data.componentes;
					console.log(data.componentes);
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error, 'Erro', this.errorToastOptions);
			}
		},
		goToDetails(componenteId) {
			this.$router.push({ path: `/ecommerce/componentes/editar/${componenteId}` });
		},
		async updateComponentOrder(evt) {
			if (!evt.moved) return;
			// this.componentes = componentes;
			console.log(evt);

			// if (evt.moved) {
			// 	this.componentes = this.componentes.map((componente, index) => ({
			// 		...componente,
			// 		ordem: index + 1,
			// 	}));
			// }

			// this.componentes = this.componentes.splice(
			// 	evt.moved.newIndex,
			// 	0,
			// 	this.componentes.splice(evt.moved.oldIndex, 1)[0]
			// );
			// remove oldIndex from this.componentes and insert at newIndex

			// remove newIndex from array

			// find evt.moved.element.componente_id and remove it from this.componentes
			const indexToRemove = this.componentes.findIndex(
				(x) => x.componente_id === evt.moved.element.componente_id
			);
			this.componentes.splice(indexToRemove, 1);

			this.componentes.splice(evt.moved.newIndex, 0, evt.moved.element);

			// todo: mover para função de reordenar. Separar função de criar e reutilizar request.
			const updatedComponents = this.componentes.map((componente, index) => ({
				...componente,
				ordem: index + 1,
			}));

			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENTE_CREATE}`;
				const { data } = await ecAxios.connection().post(url, updatedComponents);
				if (!data.error) {
					// this.getAllComponents();
					this.componentes = data.componentes;

					this.$toast.success(data.message, 'Sucesso', this.errorToastOptions);
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.warning(error.message, this.errorToastOptions);
			}
		},
		async createComponent(e) {
			if (e) e.preventDefault();
			if (!this.formData.tipo_id) {
				this.$toast.warning('Você precisa selecionar o tipo do componente', this.errorToastOptions);
				return;
			}

			this.componentes.splice(this.formData.ordem - 1, 0, {
				...this.formData,
				tipo: {
					tipo_id: this.formData.tipo_id,
				},
				pagina: {},
			});

			const updatedComponents = this.componentes.map((componente, index) => ({
				...componente,
				ordem: index + 1,
			}));

			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENTE_CREATE}`;
				const { data } = await ecAxios.connection().post(url, updatedComponents);
				if (!data.error) {
					// this.getAllComponents();
					this.componentes = data.componentes;
					this.formData = {
						descricao: '',
						tipo_id: null,
						pagina_id: 2,
						secao_id: 1,
						ordem: 1,
					};
					this.modalCriarComponente = false;
					this.$toast.success(data.message, 'Sucesso', this.errorToastOptions);
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.warning(error.message, this.errorToastOptions);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import '~@/style/Global.css';

.dica {
	font-size: 12px;
	padding: 5px;
	margin-top: 5px;
	border-radius: var(--default-border-radius);
	color: #1a9c54;
	background-color: #28c76f1f;

	&.alert {
		color: #dfa108;
		background-color: #ffb70314;
	}
}
.image-layout-desc {
	height: 100%;
	object-fit: scale-down;
}

.tipo-container:hover {
	border: var(--default-border-hover);
}
.tipo-container {
	width: 100%;
	box-shadow: var(--default-shadow);
	cursor: pointer;
	transition: var(--default-transition);
	padding: 5px;
	flex: none;
	display: flex;
	justify-content: center;
	align-items: center;
	border: var(--default-border);
	margin-bottom: 15px;
	margin-top: 15px;
	border-radius: 4px;
	span {
		font-size: 12px;
		text-align: center;
		margin-top: 5px;
	}
}
.tipo-selected {
	border: var(--default-border-hover);
}
.input-group {
	label {
		font-size: 14px;
		color: #999;
		margin-bottom: 5px;
	}
	input {
		border: var(--default-border);
		border-radius: 4px;
		padding: 2px;
	}
	select {
		border: var(--default-border);
		border-radius: 4px;
		padding: 4px;
	}
}
.label-select {
	font-size: 14px;
	color: #999;
	margin-bottom: 5px;
}
.tipo-box::-webkit-scrollbar {
	width: 5px;
	height: 8px;
	background-color: #f1f1f1;
}
.tipo-box::-webkit-scrollbar-thumb {
	background-color: #888;
	cursor: move;
}

.tipo-box {
	overflow-y: scroll;
	height: 200px;
	padding: 10px;
	--webkit-overflow-scrolling: touch;
}
.container-components {
	padding: 0;
	margin: 0;
	width: 100%;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
}
</style>
<style lang="scss">
#drop {
	.dropdown-menu {
		padding: 0;
	}
}
</style>

